import { isImageVariant } from './typeGuards/typeguards';
export const getPrimaryImage = (mediaList) => {
    const image = mediaList.find((item) => isImageVariant(item));
    return image;
};
